/**
 * 获取指定格式的数据
 * @param data
 * @param type  年 yyyy，月 MM，日：dd 时：hh 分：mm 秒：ss
 * @returns {string|*|number}
 */
export const getSpecialTime = (data,type) => {
    let date = new Date(data)
    let y = date.getFullYear();
    let m = date.getMonth() + 1; //获取当前月份的日期
    let d = date.getDate();
    let h = date.getHours();
    let min = date.getMinutes();
    let s = date.getSeconds();
    let mill = date.getMilliseconds();
    m=m>9?m:"0"+m;
    d=d>9?d:"0"+d;
    h=h>9?h:"0"+h;
    min=min>9?min:"0"+min;
    s=s>9?s:"0"+s;
    let dateTime = ""
    switch(type){
        case "yyyy":
            dateTime = y
            break
        case "MM":
            dateTime = m
            break
        case "dd":
            dateTime = d
            break
        case "HH":
            dateTime = h
            break
        case "mm":
            dateTime = min
            break
        case "ss":
            dateTime = s
            break
        case "yyyy-MM-dd hh:mm":
            dateTime = y+'-'+m+'-'+d+' '+h+':'+min
            break
        case "yyyy/MM/dd hh:mm":
            dateTime = y+'/'+m+'/'+d+' '+h+':'+min
            break
        case "yyyy/MM/dd hh:mm:ss":
            dateTime = y+'/'+m+'/'+d+' '+h+':'+min+':'+s
            break
        case "MM/dd hh:mm":
            dateTime = m+'/'+d+' '+h+':'+min
            break
        case "MM-dd hh:mm":
            dateTime = m+'-'+d+' '+h+':'+min
            break
        case "yyyy-MM-dd":
            dateTime = y+'-'+m+'-'+d
            break
        case "yyyy-MM":
            dateTime = y+'-'+m
            break
        case "MM-dd hh:mm:ss":
            dateTime = m+'-'+d+' '+h+':'+min+':'+s
            break
        case "yyyy-MM-dd hh:mm:ss":
            dateTime = y+'-'+m+'-'+d+' '+h+':'+min+':'+s
            break
        case "yyyy-MM-dd hh:mm:ss:mill":
            dateTime = y+'-'+m+'-'+d+' '+h+':'+min+':'+s+":"+mill
            break
        case "yyyy-MM-dd hh:mm":
            dateTime = y+'-'+m+'-'+d+' '+h+':'+min
            break
        case "年-月-日":
            dateTime = y+'年'+m+'月'+d+'日 '+h+':'+min+':'+s
            break
        case "hh:mm:ss":
            dateTime = h+':'+min+':'+s
            break
        case "hh:mm":
            dateTime = h+':'+min
            break
    }
    return dateTime
}


export  function loadJsMethods(){
    let jsList = [
        // '/static/js/vendor/jquery-1.12.4.min.js',
        '/static/js/bootstrap.min.js',
        '/static/js/owl.carousel.min.js',
        '/static/js/isotope.pkgd.min.js',
        '/static/js/magnific.min.js',
        '/static/js/venobox.min.js',
        '/static/js/jquery.meanmenu.js',
        '/static/js/plugins.js',
        // '/static/js/main.js'
    ]
    jsList.forEach(async e=>{
        const script = document.createElement('script');
        script.src = e;
        script.onload = () => {
            // 文件加载完毕后的回调
           console.log('External JS file loaded!');
        };
        await document.head.appendChild(script);
    })
}
